// Wraps Firebase Auth operations so components never import firebase/auth directly.
// All functions use the auth singleton from config/firebase.js.

import {
	signInWithEmailAndPassword,
	createUserWithEmailAndPassword,
	signOut,
	sendPasswordResetEmail,
	onAuthStateChanged,
} from 'firebase/auth';
import { auth } from '../config/firebase';

// Signs in with email + password. Returns a Firebase UserCredential promise.
export const signIn = (email, password) =>
	signInWithEmailAndPassword(auth, email, password);

// Creates a new account with email + password. Returns a Firebase UserCredential promise.
export const signUp = (email, password) =>
	createUserWithEmailAndPassword(auth, email, password);

// Signs out the current user. Named signOutUser to avoid collision with Firebase's signOut.
export const signOutUser = () => signOut(auth);

// Sends a password reset email. Accepts an optional email argument — if omitted,
// falls back to the currently signed-in user's email. Throws if no email is available.
export const sendPasswordReset = (email) => {
	const targetEmail = email || (auth.currentUser && auth.currentUser.email);
	if (!targetEmail) {
		throw new Error(
			'No email available for password reset. Provide an email or ensure a user is signed in.',
		);
	}
	return sendPasswordResetEmail(auth, targetEmail);
};

// Subscribes to auth state changes (sign in / sign out). Returns the unsubscribe function —
// call it in a useEffect cleanup to avoid memory leaks (see p1-authfix).
export const observeAuthState = (callback) =>
	onAuthStateChanged(auth, callback);
